/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState, useEffect, Fragment } from 'react';
import { Spinner, SpinnerSize, Modal, TextField, Callout, DirectionalHint } from '@fluentui/react';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import axios from 'axios';
import ClockInModal from './ClockInModal';

const lineContainer = () => css`
    display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 24px;
    margin-bottom: 20px;
  .line {
  flex-grow: 1;
  height: 1px;
  background-color: #ccc; /* Adjust color as needed */
}

.text {
  padding: 0 10px; /* Adjust padding for spacing */
  color: #555; /* Adjust text color */
  font-size: 16px; /* Adjust font size */
  white-space: nowrap;
}
`;

const line = () => css`
    width: 1px;
    height: 285px;
    margin-top: 75px;
    background-color: rgb(217, 217, 217);
    margin: 72px 50px;
`;

const container = () => css`
.submit-btn {
    height: 50px;
    margin-top: 25px;
    font-size: 18px;
    border-radius: 5px;
}
.ms-TextField-fieldGroup{
    overflow: visible;
}
`;

function TimeClock(props) {
    const [value, setValue] = useState("");
    const [time, setTime] = useState("");
    const [session, setSession] = useState("");
    const [loading, setLoading] = useState(true);
    const [timeClockData, setTimeClockData] = useState();
    const [error, setError] = useState(false);

    const [errors, setErrors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [user, setUser] = useState();
    const [showPad, setShowPad] = useState(false);
    const [ev, setEv] = React.useState(null);
    const [errorMessage, setErrorMessage] = useState(false);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [emailError, setEmailError] = useState(undefined);
    const [passwordError, setPasswordError] = useState(undefined);


    const handlePinChange = (event) => {
        delete errors['description'];

        const re = /^[0-9\b]+$/;
        if (event.target.value === '' || re.test(event.target.value)) {
            setValue(event.target.value.slice(0, 4))
        }

        setErrors(errors);
    }

    function showTime() {
        var date = new Date();
        var h = date.getHours(); // 0 - 23
        var m = date.getMinutes(); // 0 - 59
        var s = date.getSeconds(); // 0 - 59
        var session = "AM";

        if (h == 0) {
            h = 12;
        }

        if (h > 12) {
            h = h - 12;
            session = "PM";
        }

        h = (h < 10) ? "0" + h : h;
        m = (m < 10) ? "0" + m : m;
        s = (s < 10) ? "0" + s : s;

        var time = h + ":" + m;
        setTime(time);
        setSession(session);
        setTimeout(showTime, 1000);

    }

    useEffect(() => {
        showTime();
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        axios.get(AUTH_CONFIG.API_URL + '/api/Schedules/TimeClockDataGet?Guid=' + token).then(response => {
            if (response.data === 0) {
                window.location.href = "/login";
            }
            setTimeClockData(response.data)
            setLoading(false)
        })
    }, []);

    

   
    const handleSubmit = () => {
        setError(false);
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const model = { Id: value, Guid: token };

        axios.post(AUTH_CONFIG.API_URL + '/api/account/PostClockIn', model)
            .then((response) => {
                setShowPad(false);
                setEv(null);
                // kill focus so onFocus won't re-fire
                if (document.activeElement && typeof document.activeElement.blur === 'function') {
                    document.activeElement.blur();
                }

                if (response.data != 0) {
                    setUser(response.data);
                    setShowModal(true);
                } else {
                    setError(true);
                }
                setValue("");
            });
    };

    const openViewShift = (e) => {
        e.preventDefault();
        if (showModal) return; // don't open pad when modal is visible
        setEv(e.currentTarget);
        setShowPad(true);
        e.stopPropagation();
    };

    const numberClick = (e, n) => {
        e.preventDefault();
        setValue((value + n).slice(0, 4))
    }

    const numberBackClick = (e) => {
        e.preventDefault();
        var str = value.substring(0, value.length - 1);
        setValue(str)
    }

    const signout = (e) => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        axios.get(AUTH_CONFIG.API_URL + '/api/Schedules/TimeClockDeactivate?Guid=' + token).then(response => {
            window.location.href = "/login";
        })
    }

    const handleSubmitUsername = (event) => {
        setError(false)
        setPasswordError(undefined)
        setEmailError(undefined)
        setErrorMessage(undefined)
        let hasErrors = false;
        event.preventDefault();
        if (!email) {
            setEmailError("Please provide your email")
            hasErrors = true;
        }
        if (!password) {
            setPasswordError("Please provide your password")
            hasErrors = true;
        }

        if (hasErrors) {
            return;
        }
        debugger;
        setLoading(true)
        var model = {
            Email: email,
            Password: password
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/ClockIn", model)
            .then((response) => {
                setLoading(false)
                if (response.data != 0) {
                    setUser(response.data);
                    setShowModal(true)
                    
                } else {
                    setError(true)
                }
                setEmail('');
                setPassword('');
            })
            .catch((error) => {
                setErrorMessage(true)
                setLoading(false)
                setEmail('');
                setPassword('');
            });
        return false;
    }

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
        setEmailError(undefined)
    };

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError(undefined)
    };

    return (
        <div className="flexcolumn displayflex flex1 height100" css={container} style={{ backgroundColor: 'rgba(var(--palette-neutral-2, 248, 248, 248), 1)' }}>
            <div className=" displayflex  flexcolumn flex1">
                <div className=" displayflex  spacebetween p20 pabsolute width100">
                    <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/teamsly-logo-35.png" className=" mr10" style={{ height: 24 }} />
                    <a href="" onClick={(e) => signout(e)}>Sign Out</a>
                </div>
                <div className="displayflex justifycenter aligncenter height100">
                    <div className="displayflex justifycenter">
                        <div>
                            <h3 className="head-30 mb10">Clock In</h3>
                            <h5 className="head-xs ">Employee pin</h5>
                            {error && <h5 className="head-xs danger mt5" style={{ color: 'var(--danger)' }}>Incorrect pin, please try again.</h5>}
                            
                            <div className="clockin-input spacebetween displayflex mt10">
                                <div className="displayflex width100">
                                    <TextField value={value} rows={1} name="clock-in" maxLength={4} className="width100 pin" onFocus={(e) => openViewShift(e)} onChange={handlePinChange} />
                                    {showPad && !showModal && (
                                        <Callout
                                            isBeakVisible={false}
                                            className="template-block-popup"
                                            gapSpace={5}
                                            doNotLayer={false}
                                            target={ev}
                                            directionalHint={DirectionalHint.bottomRightEdge}
                                            onDismiss={() => setShowPad(false)}
                                            setInitialFocus={false}
                                        >
                                        <div class="clock-in">
                                            <div class="cal box trade-card">
                                                <ul class="buttons">
                                                    <li><button class="val" onClick={(e) => numberClick(e, "1")}>1</button></li>
                                                        <li><button class="val" onClick={(e) => numberClick(e, "2")}>2</button></li>
                                                        <li><button class="val" onClick={(e) => numberClick(e, "3")}>3</button></li>
                                                </ul>
                                                <ul class="buttons">

                                                        <li><button class="val" onClick={(e) => numberClick(e, "4")}>4</button></li>
                                                        <li><button class="val" onClick={(e) => numberClick(e, "5")}>5</button></li> 
                                                        <li><button class="val" onClick={(e) => numberClick(e, "6")}>6</button></li>
                                                </ul>
                                                <ul class="buttons">
                                                        <li><button class="val" onClick={(e) => numberClick(e, "7")}>7</button></li>
                                                        <li><button class="val" onClick={(e) => numberClick(e, "8")}>8</button></li>
                                                        <li><button class="val" onClick={(e) => numberClick(e, "9")}>9</button></li>
                                                </ul>
                                               
                                                <ul class="buttons">
                                                        <li><button class="val" href="1" onClick={(e) => numberBackClick(e)}>
                                                        <svg style={{width:30}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                            <path d="M135.19 390.14a28.79 28.79 0 0021.68 9.86h246.26A29 29 0 00432 371.13V140.87A29 29 0 00403.13 112H156.87a28.84 28.84 0 00-21.67 9.84v0L46.33 256l88.86 134.11z" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32" />
                                                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M336.67 192.33L206.66 322.34M336.67 322.34L206.66 192.33M336.67 192.33L206.66 322.34M336.67 322.34L206.66 192.33" />
                                                        </svg>
                                                        </button></li>
                                                        <li><button class="val" onClick={(e) => numberClick(e, "0")} >0</button></li>
                                                        <li><button onClick={() => handleSubmit()} className={`val ${value.length > 1 ? 'active' : 'disabled'}`} disabled={!value.length} style={{ fontSize: 18, fontWeight: 400 }}>GO</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                        </Callout>)
                                    }
                                </div>
                            </div>
                            <div css={lineContainer }>
                                <div class="line"></div>
                                <span class="text">or</span>
                                <div class="line"></div>
                            </div>
                            <form onSubmit={handleSubmitUsername}>
                                {errorMessage && <h5 className="head-xs danger mt5 mb20" style={{ color: 'var(--danger)' }}>The username or password is not correct.</h5>}
                                <div className="flexcolumn">
                                    <h5 className="head-xs ">Username</h5>
                                    <div className="clockin-input spacebetween displayflex mt10">
                                        <div className="displayflex width100">
                                            <TextField
                                                rows={1}
                                                name="email"
                                                className="width100"
                                                errorMessage={emailError}
                                                value={email}
                                                onChange={handleEmailChange} />
                                        </div>
                                    </div>
                                    <h5 className="head-xs mt15">Password</h5>
                                    <div className="clockin-input spacebetween displayflex mt10">
                                        <div className="displayflex width100">
                                            <TextField
                                                errorMessage={passwordError}
                                                id="password"
                                                type="password"
                                                value={password}
                                                canRevealPassword
                                                onChange={handlePasswordChange}
                                                rows={1}
                                                name="password"
                                                className="width100"/>
                                        </div>
                                    </div>
                                </div>
                                {email.length > 6 && password.length > 6 && <div>
                                    <button type="submit" className="submit-btn ms-Button ms-Button--primary mt15 continue width100" style={{ color: '#fff', border: 'none' }}>{!loading ? "Clock in" : <Spinner size={SpinnerSize.small} />}</button>
                                </div>}
                            </form>
                        </div>
                        <div css={line }></div>
                        <div className="displayflex aligncenter" style={{ fontSize: 110, fontWeight: 300 }}>{time}<span style={{ fontSize: 50, marginTop:43 }}>{session}</span></div>
                        {/* <Clock />*/}
                    </div>
                </div>
            </div>
          
            {showModal &&
                <Modal
                    isOpen={showModal}
                    isBlocking={false}
                    setInitialFocus={false}
                    onDismiss={() => {
                        setShowModal(false);
                        setShowPad(false);
                        setEv(null);
                        setValue("");
                    }}
                    className="dark-overlay"
                    firstFocusableSelector="blah"
                    disableFirstFocus={true}
                >
                    <ClockInModal
                        close={() => { setShowModal(false); setShowPad(false); setEv(null); setValue(""); }}
                        user={user}
                        data={timeClockData}
                        facilityId={timeClockData.facilityId}
                        clientsModule={timeClockData?.clientsModule}
                        requireJobCode={timeClockData?.requireJobCode}
                        timecardClientRoles={timeClockData?.timecardClientRoles}
                    />
                </Modal>
            }
           


        </div>
    );
}

export default TimeClock;
